const items = [
  { key: 'attach-template', label: 'Pilih Template Pengiriman' },
  { key: 'scheduler', label: 'Atur Penjadwalan' },
]

export default items